// both of these functions are inspired by
// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

export const isBrave = async () =>
  (navigator.brave && (await navigator.brave.isBrave())) || false;

// Safari 3.0+ "[object HTMLElementConstructor]"
export const isSafari = () => {
  return (
    /constructor/i.test(window.HTMLElement.toString()) ||
    (
      !window.safari ||
      (typeof safari !== 'undefined' && window.safari.pushNotification)
    ).toString() === '[object SafariRemoteNotification]'
  );
};
